function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M256,0C114.508,0,0,114.497,0,256c0,141.493,114.497,256,256,256c141.492,0,256-114.497,256-256 C512,114.507,397.503,0,256,0z M256,472c-119.384,0-216-96.607-216-216c0-119.385,96.607-216,216-216 c119.384,0,216,96.607,216,216C472,375.385,375.393,472,256,472z"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M343.586,315.302L284.284,256l59.302-59.302c7.81-7.81,7.811-20.473,0.001-28.284c-7.812-7.811-20.475-7.81-28.284,0 L256,227.716l-59.303-59.302c-7.809-7.811-20.474-7.811-28.284,0c-7.81,7.811-7.81,20.474,0.001,28.284L227.716,256 l-59.302,59.302c-7.811,7.811-7.812,20.474-0.001,28.284c7.813,7.812,20.476,7.809,28.284,0L256,284.284l59.303,59.302 c7.808,7.81,20.473,7.811,28.284,0C351.398,335.775,351.397,323.112,343.586,315.302z"
})));

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var _ref17 =
/*#__PURE__*/
React.createElement("g", null);

var _ref18 =
/*#__PURE__*/
React.createElement("g", null);

var SvgErrorIcon = function SvgErrorIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgErrorIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ErrorIcon.49cbfff0.svg";
export { ForwardRef as ReactComponent };